import React from "react";

import { getSearchSeoTitle, unSlugify } from "utils/strings";
import { SearchHeaderProps } from "./SearchHeader";
import styles from "./Heading.module.scss";

export const Heading = (props: SearchHeaderProps) => {
    const {
        location, keyword, company, category, state
    } = props;
    const total = state.totalCount;

    const headerStringObj = getSearchSeoTitle(
        location,
        unSlugify(keyword),
        company,
        category,
        total,
    );

    return (
        <h1 className={styles.total} data-testid="search-heading">
            {total > 0 && (<span>{headerStringObj.totalString}</span>)}
            {headerStringObj.suffix}
        </h1>
    );
};

Heading.displayName = "Heading";
